var map = {
	"./031-drawkit-phone-conversation-colour.svg": "b8c8",
	"./077-student-colour.svg": "f419",
	"./078-student-monochrome.svg": "70e0",
	"./ISS.jpg": "b7fb",
	"./asteroids.jpg": "1f8f",
	"./avatars/boy_black_specs.png": "ced4",
	"./avatars/boy_black_stache.png": "16c4",
	"./avatars/boy_white_earphones_hoodie.png": "ddbc",
	"./avatars/boy_white_futuristic_brown.png": "23b5",
	"./avatars/default.png": "da9a",
	"./avatars/girl_black_earrings.png": "c196",
	"./avatars/girl_black_mask.png": "d3d1",
	"./avatars/girl_white.png": "5dba",
	"./avatars/girl_white_green.png": "64a5",
	"./exoplanet.jpg": "e6b9",
	"./feedback-humaaans.svg": "9796",
	"./flares_of_fury.jpg": "4aad",
	"./icons8-asteroid-64.png": "af08",
	"./icons8-mars-60.png": "bf84",
	"./icons8-radar-64.png": "31dd",
	"./icons8-space-station-64.png": "d24c",
	"./mars-rover.jpg": "6abd",
	"./planet-with-no-star.jpg": "cd65",
	"./rains_of_terror.jpg": "8d18",
	"./roasted_planet.jpg": "3ded",
	"./space-coming-soon.png": "f58a",
	"./space-error.png": "2ee1",
	"./space-page-under-construction.png": "a0d7",
	"./zombie_psr.jpg": "f787"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";